import { styled } from '@pata-app/themes';

export const TilesContainer = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 32px;

  margin-top: 60px;

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    column-gap: 160px;
    row-gap: 60px;

    width: 100%;
    max-width: 1000px;

    margin: auto;
    margin-top: 60px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.Xl}`} {
    width: 60%;
  }
`;
